import * as React from "react";
import { PartsMessage } from "../PartsMessage";
import { PartsFilter } from "../partsStatus.utils";

// "Jobs but no orders" can mean parts were never ordered, so it gets its own message.
export const PartsEmptyState: React.FC<{ hasJobsToday: boolean; hasAnyOrders: boolean; filter: PartsFilter }> = ({
  hasJobsToday,
  hasAnyOrders,
  filter,
}) => {
  if (!hasJobsToday) {
    return <PartsMessage title="Nothing scheduled today" body="When you have jobs, the parts for them show up here." />;
  }
  if (!hasAnyOrders) {
    return (
      <PartsMessage
        title="No part orders for today's jobs"
        body="Nothing has been ordered for your jobs yet. Check with dispatch if you were expecting parts."
      />
    );
  }
  return (
    <PartsMessage
      title={filter === "COLLECTED" ? "Nothing picked up yet" : "Nothing ordered to pick up"}
      body="You have orders today — switch tabs to see them."
    />
  );
};
